{
  "mappings": [
    {
      "category": "Account Information",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "User-Generated Content",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Communication Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "AI Interaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Device Interaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Transaction Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Contact Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Usage Data",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Device Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Location Data",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Content Analysis Data",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Biometric Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Metadata",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Tracking Technologies",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Third-Party Information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Advertising Data",
      "titles": ["user_data_tiktok.json"]
    },
    {
      "category": "Transaction Support Data",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Miscellaneous Data",
      "titles": ["no_matching_file"]
    }
  ]
}
